module.exports = __webpack_public_path__ + "static/media/CircularStd-Black.b9fb083e.eot";